
import DatePicker from 'vue2-datepicker3.11.1';
import 'vue2-datepicker3.11.1/index.css';
import Vue from 'vue';
import Moment from 'moment';

// Local variables
let shortcutUsed = false;
let shortcutText = '';
const DAY = 3600 * 1000 * 24;
const DATE_FORMAT = 'MMMM, DD, YYYY';

interface IShortcut {
  text: string;
  onClick: Function;
}

interface IData {
  inputValue: string;
  value: Date[];
  settings: {
    formatLocale: {
      firstDayOfWeek: number;
      firstWeekContainsDate: number;
    };
  };
  shortcuts: IShortcut[];
  open: boolean;
}

export default Vue.extend({
  components: {
    DatePicker,
  },
  data(): IData {
    return {
      inputValue: '',
      value: [],
      open: false,
      settings: {
        formatLocale: {
          firstDayOfWeek: 1,
          firstWeekContainsDate: 1
        },
      },
      shortcuts: [
        {
          text: 'Today',
          onClick() {
            const date = new Date();
            shortcutUsed = true;
            shortcutText = 'Today';
            return [date, date];
          },
        },
        {
          text: 'Yesterday',
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - DAY);
            shortcutUsed = true;
            shortcutText = 'Yesterday';
            return [date, date];
          },
        },
        {
          text: 'Last 7 days',
          onClick() {
            const date1 = new Date();
            const date2 = new Date();
            date1.setTime(date1.getTime() - DAY * 7);
            shortcutUsed = true;
            shortcutText = 'Last 7 days';
            return [date1, date2];
          },
        },
        {
          text: 'Last 30 days',
          onClick() {
            const date1 = new Date();
            const date2 = new Date();
            date1.setTime(date1.getTime() - DAY * 30);
            shortcutUsed = true;
            shortcutText = 'Last 30 days';
            return [date1, date2];
          },
        },
        {
          text: 'This month',
          onClick() {
            const date1 = new Date();
            const date2 = new Date();
            date1.setDate(1);
            shortcutUsed = true;
            shortcutText = 'This month';
            return [date1, date2];
          },
        },
        {
          text: 'Previous month',
          onClick() {
            const date1 = new Date();
            const date2 = new Date();
            date1.setMonth(date1.getMonth() - 1);
            date1.setDate(1);
            // This jumps back to last day of the previous month
            date2.setDate(0);
            shortcutUsed = true;
            shortcutText = 'Previous month';
            return [date1, date2];
          },
        },
      ],
    };
  },
  mounted() {
    // Check if dates already exists in query params, and go with that
    if (this.$route.query.date) {
      if (
        this.$route.query.date.includes('~') &&
        typeof this.$route.query.date === 'string'
      ) {
        // Dates in the query param
        const split = this.$route.query.date.split('~');
        // Fix timezone mess
        const date1 = Moment(split[0]);
        const date2 = Moment(split[1]);
        this.setRangeDate([date1.toDate(), date2.toDate()]);
        return;
      } else {
        // Probably dynamic shortcut in query param
        const date = this.$route.query.date;
        const found = this.shortcuts.find(s => s.text === date);
        if (found) {
          const dates = found.onClick();
          this.setRangeDate(dates);
          return;
        }
      }
    }
    // Activating initial shortcut for the datepicker
    // ATM its Last 7 days
    const dates = this.shortcuts[2].onClick();
    this.setRangeDate(dates);
    this.value = dates;
  },
  methods: {
    async setRangeDate(val: Date[]) {
      this.$emit('set-date-range', val);
      const day1 = Moment(val[0]);
      const day2 = Moment(val[1]);
      if (day1.utcOffset() > 0) {
        day1.add(day1.utcOffset(), 'minutes');
        day2.add(day2.utcOffset(), 'minutes');
      } else {
        day1.subtract(day1.utcOffset(), 'minutes');
        day2.subtract(day2.utcOffset(), 'minutes');
      }
      if (shortcutUsed) {
        shortcutUsed = false;
        this.setInputDate(shortcutText);
        if (this.$route.query.date !== shortcutText) {
          await this.$router.push({
            query: Object.assign({}, this.$route.query, { date: shortcutText }),
          });
        }
        shortcutText = '';
      } else {
        this.setInputDate(
          `${day1.format(DATE_FORMAT)} - ${day2.format(DATE_FORMAT)}`
        );
        // Set query parameters
        const date = `${day1.format('YYYY-MM-DD')}~${day2.format(
          'YYYY-MM-DD'
        )}`;
        if (this.$route.query.date !== date) {
          await this.$router.push({
            query: Object.assign({}, this.$route.query, {
              date,
            }),
          });
        }
      }
      this.value = [day1.toDate(), day2.toDate()];
      this.$store.dispatch('insights/setDateRange', [
        day1.toDate(),
        day2.toDate(),
      ]);
    },
    setInputDate(val) {
      this.inputValue = val;
    },
    toogleDatePicker() {
      this.open = !this.open;
    },
    closeDatePicker() {
      this.open = false;
    },
  },
});
